import { formatNumberAbbreviated } from 'apps/app/src/utils/number';
import type { ChartOptions } from 'chart.js';
import { newVyPalette } from '../../../../assets/themes/new-vy/palette';

export const usageLineItemBarChartOptions: ChartOptions<'bar'> = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    y: {
      border: {
        dash: [2, 5],
        display: false,
      },
      ticks: {
        font: {
          size: 14,
          family: 'Inter, sans-serif',
        },
        color: '#9F9F9F',
        callback(val) {
          const formattedVal = formatNumberAbbreviated(Number(val));
          const emptySpaceToAdd = formattedVal.length < MAX_LABEL_LENGTH ? ' '.repeat(MAX_SPACES_TO_ADD - formattedVal.length) : ' ';

          return `${emptySpaceToAdd}${formattedVal}`;
        },
      },
    },
    x: {
      border: {
        display: true,
        color: '#C2C2C2',
      },
      ticks: {
        font: {
          size: 10,
          family: 'Inter, sans-serif',
        },
        color: '#9F9F9F',
      },
      grid: {
        display: false,
      },
    },
  },
  datasets: {
    bar: {
      barThickness: 13,
      borderRadius: 4,
    },
  },
  plugins: {
    legend: {
      position: 'top' as const,
      align: 'end' as const,
      labels: {
        boxWidth: 12,
        boxHeight: 12,
        useBorderRadius: true,
        borderRadius: 4,
        font: {
          size: 12,
          family: 'Inter, sans-serif',
        },
      },
    },
    title: {
      display: true,
      text: 'Usage Metrics',
      align: 'start' as const,
      color: '#909090',
      font: {
        size: 16,
        family: 'Inter, sans-serif',
        weight: 'normal',
      },
    },
  },
};

export const barColors = [newVyPalette.primary.main, newVyPalette.secondary.main, newVyPalette.tertiary.main];

const MAX_LABEL_LENGTH = 4;
const MAX_SPACES_TO_ADD = 8;